import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSocial = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 6,
			fill: "#24A2C2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5160_9813)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M25.1666 23.5V21.8333C25.1661 21.0948 24.9203 20.3773 24.4678 19.7936C24.0153 19.2099 23.3817 18.793 22.6666 18.6083",
					stroke: "#DFF1FA",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1667 23.5V21.8333C20.1667 20.9493 19.8155 20.1014 19.1904 19.4763C18.5653 18.8512 17.7174 18.5 16.8334 18.5H10.1667C9.28265 18.5 8.43481 18.8512 7.80968 19.4763C7.18456 20.1014 6.83337 20.9493 6.83337 21.8333V23.5",
					stroke: "#DFF1FA",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.3334 8.60834C20.0504 8.79192 20.6859 9.20892 21.1397 9.7936C21.5936 10.3783 21.8399 11.0974 21.8399 11.8375C21.8399 12.5776 21.5936 13.2967 21.1397 13.8814C20.6859 14.4661 20.0504 14.8831 19.3334 15.0667",
					stroke: "#DFF1FA",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5 15.1667C15.3409 15.1667 16.8333 13.6743 16.8333 11.8333C16.8333 9.99238 15.3409 8.5 13.5 8.5C11.659 8.5 10.1666 9.99238 10.1666 11.8333C10.1666 13.6743 11.659 15.1667 13.5 15.1667Z",
					stroke: "#DFF1FA",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5160_9813",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(6 6)"
			})
		}) })
	]
});
export default SvgSocial;
